import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import { language } from "@/Router";

// import { initReactI18next } from "react-i18next";
import de_DE from "./de_DE";
import en_US from "./en_US";

//noinspection JSIgnoredPromiseFromCall
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ["regiolux"], //important to overwrite the default ns of cpq
    defaultNS: "regiolux",
    debug: true,
    lng: language ? language : "en-GB",
    fallbackLng: "en-GB",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      "en-US": en_US,
      "en-GB": en_US,
      "de-DE": de_DE,
    },
  });

export default i18n;
